export default __webpack_public_path__ + "static/char-s-61-en-526465043a70a5d74e4f94b6de0822c0.webp";